export class ProductHashTagViewModel {
    public productHashTagId: string;
    public hashTagId: string;
    public hashTagName: string;
    public displaySequence: number;
    public inheritHashTag: boolean;
    public param: boolean;
}
